import { SECTION_POST_LIST, SECTION_RELATED_POSTS, FEED_PAGE_SECTIONS, } from '../sections';
export const VIDEO_SETTINGS_NAMES = {
    PLAY: 'play',
    SOUND: 'sound',
    PLAYBACK_SPEED: 'playbackSpeed',
    LOOP: 'loop',
    SHOW_PLAY_BUTTON: 'showPlayButton',
};
export const playValuesToProGalleryMap = ['hover', 'auto', 'onClick'];
export const playbackSpeedValuesToProGalleryMap = [
    '0.25',
    '0.5',
    '1',
    '1.25',
    '1.50',
    '2',
];
export const VIDEO_SETTINGS = {
    [VIDEO_SETTINGS_NAMES.PLAY]: {
        defaultValue: 0,
        param: 'play',
        appSettingsPath: 'style.numbers.postListWidgetPostsPerPage',
        values: {
            ON_HOVER: 0,
            AUTOPLAY: 1,
            ON_CLICK: 2,
        },
    },
    [VIDEO_SETTINGS_NAMES.SOUND]: {
        defaultValue: false,
        param: 'sound',
    },
    [VIDEO_SETTINGS_NAMES.PLAYBACK_SPEED]: {
        defaultValue: 2,
        param: 'playbackSpeed',
        values: {
            '0.25x': 0,
            '0.5x': 1,
            '1x': 2,
            '1.25x': 3,
            '1.5x': 4,
            '2x': 5,
        },
    },
    [VIDEO_SETTINGS_NAMES.LOOP]: {
        defaultValue: true,
        param: 'loop',
    },
    [VIDEO_SETTINGS_NAMES.SHOW_PLAY_BUTTON]: {
        defaultValue: true,
        param: 'showPlayButton',
    },
};
const getSection = (section) => {
    if (section === SECTION_POST_LIST) {
        return SECTION_POST_LIST;
    }
    if (section === SECTION_RELATED_POSTS) {
        return SECTION_RELATED_POSTS;
    }
    if (FEED_PAGE_SECTIONS.includes(section)) {
        return 'feed-page';
    }
    return 'unknown';
};
export const getVideoSectionWixparam = (section, param) => {
    return `${getSection(section)}-video-${VIDEO_SETTINGS[param].param}`;
};
export const getVideoSectionAppSettingsPath = (section, param) => {
    if (typeof VIDEO_SETTINGS[param].defaultValue === 'number') {
        return `style.numbers.${getVideoSectionWixparam(section, param)}`;
    }
    return `style.booleans.${getVideoSectionWixparam(section, param)}`;
};
//# sourceMappingURL=post-video-params.wix-params.js.map